export const clientStatusAdm = [
  { id: 1, label: 'clientStatusAdm.initial', value: 'Initial' },
  { id: 8, label: 'clientStatusAdm.submitted', value: 'Submitted' },
  { id: 7, label: 'clientStatusAdm.paid', value: 'Paym. Confirmed' },
  // { id: 2, label: 'clientStatusAdm.received', value: 'Received' },
  { id: 3, label: 'clientStatusAdm.preparing', value: 'Preparing' },
  { id: 4, label: 'clientStatusAdm.draftSent', value: 'Draft sent' },
  { id: 5, label: 'clientStatusAdm.signed', value: 'Signed' },
  { id: 6, label: 'clientStatusAdm.filled', value: 'Filled' },
];

export const administratorStatusAdm = [
  // { id: 1, label: 'administratorStatusAdm.verified', value: 'Verified' },
  // {
  //   id: 2,
  //   label: 'administratorStatusAdm.readyForReview',
  //   value: 'Ready for review',
  // },
  // { id: 3, label: 'administratorStatusAdm.reviewed', value: 'Reviewed' },
  {
    id: 0,
    label: 'administratorStatusAdm.unassigned',
    value: 'Unassigned',
  },
  {
    id: 1,
    label: 'administratorStatusAdm.readyVictor',
    value: 'Ready for Victor',
  },
  { id: 2, label: 'administratorStatusAdm.readyAlex', value: 'Ready for Alex' },
  {
    id: 3,
    label: 'administratorStatusAdm.readyLucas',
    value: 'Ready for Lucas',
  },
  {
    id: 4,
    label: 'administratorStatusAdm.readyForReview',
    value: 'Ready for Review',
  },
  {
    id: 8,
    label: 'administratorStatusAdm.readyForReviewLucas',
    value: 'Ready for Review - Lucas',
  },
  {
    id: 5,
    label: 'administratorStatusAdm.missingInformation',
    value: 'Missing information',
  },
  {
    id: 6,
    label: 'administratorStatusAdm.sentToClient',
    value: 'Sent to client',
  },
  {
    id: 9,
    label: 'administratorStatusAdm.sentToClientInvoiced',
    value: 'Sent to client/Invoiced',
  },
  {
    id: 10,
    label: 'administratorStatusAdm.paymentReceived',
    value: 'Payment received',
  },
  { id: 7, label: 'administratorStatusAdm.completed', value: 'Completed' },
  { id: 11, label: 'administratorStatusAdm.canceled', value: 'Canceled' },
];
